<template>
    <div>
        <PedidoCompraContentPdf ref="pedidoContentPdf" :image="image" :compra="compra" :index="index" @handleHtmlContent="printHtmlContent" />
    </div>
</template>

<script>
import { apiORDS, apiORDSapp, apiORDSmidia, apiDownloadPDF } from '../shared/api-functions'
import PedidoCompraContentPdf from './pedido-compra-content-pdf.vue'

export default {
    components:{
        PedidoCompraContentPdf
    },
    props: {
        index: {
            type: Number,
            require: true
        },
    },
    data() {
        return {
            compra: null,
            uuid: null,
            image: null,
        }
    },
    computed:{
        orderId(){
            if(this.compra){
                return 'Pedido de Compra: ' + this.compra.npedido
            }
        },
    },
    methods: {
      async loadData() {
          console.log(this.uuid)
          if (this.uuid) {
              const data = await apiORDSapp(this, 'linkpdf/imprimircompra/' + this.uuid, 'get', null)
              if (data) {
                  this.compra = data.items[0]
                  if (this.compra.filial.length && this.compra.filial[0].logotipo) {
                      this.image = 'data:image/jpeg;base64,' + this.compra.filial[0].logotipo
                  }
                  this.print()
              }
          } else {
              const data = await apiORDS(this.$store.getters.urlOrds + 'purchase/compra/' + this.index + '/print', null)
              if (data) {
                  if (!this.image && data.items[0].filial.length) {
                      let self = this
                      await apiORDSmidia(this.$store.getters.urlApp + 'logo/download/' + data.items[0].filial[0].codempresa + '/' + data.items[0].filial[0].codfil).then(
                          response => {
                              if (response && response.size > 0) {
                                  let reader = new window.FileReader();
                                  reader.readAsDataURL(response);
                                  reader.onload = function() {
                                      self.image = reader.result;
                                  }
                              }
                          }
                      )
                  }
                  this.compra = data.items[0]
              }
          }
      },

      printHtmlContent(htmlContent) {
          let filename = this.orderId
          filename = filename.replace(': ', '') + '.pdf'
          const sendData = { header: htmlContent[0], body: htmlContent[1] }
          apiDownloadPDF(this, '/htmlpdf', sendData, 'post', false, filename)
          this.$emit('close');
      },

      print() {
          this.$refs.pedidoContentPdf.getHtmlContent();
      }
    },
    created () {
        console.log(this.$route)
        if (this.$route.name == 'imprimir-compra') {
            if (this.$route.query && this.$route.query.uuid) {
                this.uuid = this.$route.query.uuid
            } else {
                this.$router.push('/login')
                return
            }
        }

        this.loadData();

    },
}
</script>



// WEBPACK FOOTER //
// src/forms/pedido-compra-impressao.vue